<script lang="ts">
  import {box, mergeProps} from "svelte-toolbelt";
  import {useCalendarDay} from "./calendar.svelte.js";
  import {useId} from "./internal/use-id.js";

  let {
    children,
    child,
    ref = $bindable(null),
    id = useId(),
    ...restProps
  } = $props();

  const dayState = useCalendarDay({
    id: box.with(() => id),
    ref: box.with(
      () => ref,
      (v) => (ref = v)
    ),
  });

  const mergedProps = $derived(mergeProps(restProps, dayState.props));

</script>

{#if child}
  {@render child({
    props: mergedProps,
    ...dayState.snippetProps,
  })}
{:else}
  <div style="border-radius: 10px;" {...mergedProps}>
    {#if children}
      {@render children?.(dayState.snippetProps)}
    {:else}
      {dayState.cell.date.current.day}
    {/if}
  </div>
{/if}

<style>
  div {
    background-color: rgb(230, 230, 230);
    @container kalender (min-width: 400px) {
      /*padding-top: var(--calendar-day-padding);*/
      /*padding-bottom: var(--calendar-day-padding);*/
      /*padding-top: 28px;*/
      /*padding-bottom: 30px;*/
    }
  }
</style>